import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { Commissioner, CommissionerSingleResponse, StoreCommissionerRequest } from '@lib/api/models/commissioner';
import { CommissionerService } from '@lib/commissioner/commissioner.service';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { ComponentsModule, DialogService, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';

@Component({
    selector: 'app-prompt-commissioner-status-change-dialog',
    imports: [ComponentsModule, ErrorPanelComponent],
    templateUrl: './prompt-commissioner-status-change-dialog.component.html',
    standalone: true,
    styleUrl: './prompt-commissioner-status-change-dialog.component.scss'
})
export class PromptCommissionerStatusChangeDialogComponent {
    protected readonly dialogRef = inject<DialogRef>(DialogRef);
    private readonly _commissionerService = inject(CommissionerService);
    private readonly _snackBar = inject(SnackBarService);
    protected readonly commissioner = inject<Commissioner>(DIALOG_DATA);

    updateCommissionerRequest = new SendableRequest<CommissionerSingleResponse, StoreCommissionerRequest>({
        request: (payload) => this._commissionerService.updateCommissioner(this.commissioner.id, payload!),
        onSuccess: () => {
            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'Commissioner status changed successfully',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });
            this.dialogRef.close();
        },
        onError: () => {
            this._snackBar.open({
                colour: 'error',
                dismissable: false,
                icon: 'error_outline',
                title: 'Commissioner status failed to change',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });
        }
    });

    update() {
        this.updateCommissionerRequest.send({
            status: this.commissioner.status,
            reference: this.commissioner.reference,
            name: this.commissioner.name,
            email: this.commissioner.email
        });
    }


    public static show(dialog: DialogService, data: Commissioner) {
        return dialog.openDialog<DialogRef, Commissioner>(PromptCommissionerStatusChangeDialogComponent, {
                data
            }
        );
    }

}
